import React from 'react';
import { PageProps, graphql } from 'gatsby';
import { Global, css } from '@emotion/react';

import {
  BookingForm,
  NewsPreview,
  ContactLocations,
  CallsToAction,
  Hero,
  Navigation,
  GoogleMap,
  Footer,
  Article,
  SEO,
} from '@components';
import { globalStyles, MainContainer } from '@styles';

type TPostData = {
  posts: {
    post: {
      type: 'BlogPost';
      title: string;
      url: string;
      description: string;
      author: string;
      categories: string[];
      publishedTime: string;
      modifiedTime: string;
      updatedTime: string;
      breadcrumbs: { name: string; url: string }[];
      content: string;
    }[];
  };
};

const PostTemplate = (props: PageProps<TPostData>) => {
  const [data] = props.data.posts.post;

  if (data) {
    return (
      <>
        <Global styles={globalStyles} />
        <Navigation />
        <MainContainer className="main">
          <Hero
            subtitle=""
            title={data.title}
            link={{
              to: '/contact-us',
              innerText: 'Get the help you deserve',
            }}
            slim={true}
            background="streak"
          />
          <Article>{data.content}</Article>
          <ContactLocations />
          <CallsToAction
            useEmail
            cssOverrides={css`
              padding: 0 0 4rem;
            `}
          />
          <GoogleMap />
          <NewsPreview />
          <BookingForm />
          <Footer />
        </MainContainer>
      </>
    );
  }

  return <p>Something went wrong.</p>;
};

export const query = graphql`
  query PostQuery($url: String!) {
    posts: allNewsYaml(filter: { url: { eq: $url } }) {
      post: nodes {
        type
        title
        url
        description
        author
        categories
        publishedTime
        modifiedTime
        updatedTime
        breadcrumbs {
          name
          url
        }
        content
      }
    }
  }
`;

export const Head = (props: PageProps<TPostData>) => {
  const [data] = props.data.posts.post;

  if (!data) {
    return;
  }

  return (
    <SEO title={data.title} path={data.url} description={data.description} />
  );
};

export default PostTemplate;
export type { TPostData };
